import React, { Component } from 'react'; // eslint-disable-line
import ManagedInput from '../forms/ManagedInput';
import AddPlus from '../svg/AddPlus';
import CloseX from '../svg/CloseX';
import i18n from '../../i18n';

class NewProjectItem extends Component {
    constructor(props) {
        super(props);
        this.handleNew = this.handleNew.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.newProjectOnClick = this.newProjectOnClick.bind(this);
        this.state = {
            step1: true,
            step2: false,
            projectName: '',
        };
    }

    handleNew(event) {
        event.preventDefault();
        if (this.state.projectName !== '') {
            this.props.createNew(this.state.projectName);
        }
    }

    handleInput(evt) {
        const name = evt.target.value.trim();
        this.setState({
            projectName: name,
        });
    }

    newProjectOnClick() {
        this.setState((prevState) => {
            return {
                step1: !prevState.step1,
                step2: !prevState.step2,
            };
        });
    }

    render() {
        return (
            <div data-qa="project-list-new-project" className="project-list__project new-project">
                {this.state.step1
      && (
                // eslint-disable-next-line
          <div data-qa="project-list-new-project-step1" className="project-info-wrap step1" onClick={this.newProjectOnClick}>
              <h5>
                  {/* eslint-disable-next-line */}
                  <a data-qa="project-list-new-project-step1-button" id="new-project">
                      <span className="add"><AddPlus size={46} /></span>
                      <br />
                      <span className="text">{i18n.t('projects.new')}</span>
                  </a>
              </h5>
          </div>
      )}
                {this.state.step2
      && (
          <div data-qa="project-list-new-project-step2" id="create-project-step-2" className="project-info-wrap step2">
              {/* eslint-disable-next-line */}
              <div className="delete-project" onClick={this.newProjectOnClick}><CloseX /></div>
              <form onSubmit={this.handleNew}>
                  <h5>{i18n.t('projects.name')}</h5>
                  <ManagedInput
                      containerClass="input_app-display-name"
                      labelText=""
                      value={this.state.projectName}
                      name="Name"
                      placeholder={i18n.t('projects.placeholder')}
                      onChange={this.handleInput}
                      onBlur={this.handleInput}
                      onReturnDown=""
                      errorMessage=""
                      hasError={false}
                      successMessage=""
                      hasSuccess={false}
                      autoFocus
                      dataqa="project-list-new-project-step2-name-input"
                  />
                  <p className="btn-wrapper"><input data-qa="project-list-new-project-step2-start-button" id="start-project" type="submit" value={i18n.t('projects.button')} className={`btn btn-dark btn-sm ${this.state.projectName === '' ? 'btn-null' : ''}`} /></p>
              </form>
          </div>
      )}
            </div>
        );
    }
}
export default NewProjectItem;
